export default __webpack_public_path__ + "media/color/part-143bc783.svg";